import types from '../mutation-types';
import flowConfigAPI from '../../api/flowConfig';

const initialState = {
  flow: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getFlowConfig: $state => $state.flow,
  hasAccessManageFlow: $state => !!$state.flow.has_access_manage_flow,
  isFetching: $state => $state.uiFlags.isFetching,
};

export const actions = {
  async fetch({ commit }) {
    if (!window.chatwootConfig?.apiBaseUrl) return;

    commit(types.SET_FLOW_CONFIG, { uiFlags: { isFetching: true } });
    try {
      const { data } = await flowConfigAPI.getConfig();
      commit(types.SET_FLOW_CONFIG, { flow: data.flow || {} });
    } catch {
      // silently fail — menu item stays hidden
    } finally {
      commit(types.SET_FLOW_CONFIG, { uiFlags: { isFetching: false } });
    }
  },
};

export const mutations = {
  [types.SET_FLOW_CONFIG]($state, payload) {
    if (payload.flow !== undefined) {
      $state.flow = payload.flow;
    }
    if (payload.uiFlags !== undefined) {
      $state.uiFlags = { ...$state.uiFlags, ...payload.uiFlags };
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
